export default {"src":"/_next/static/media/LULU.3f3a22fc.svg","height":18,"width":18};